import { render, staticRenderFns } from "./RateDossie.vue?vue&type=template&id=573053fa&"
import script from "./RateDossie.vue?vue&type=script&lang=js&"
export * from "./RateDossie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports